<div class="container container-shadow pt-4 pb-5 my-4 mb-4" id="main-content">
  <h3 class="text-center">Font - {{ font.name }}</h3>
  <div class="row mb-4">
    <div class="col-md-6 mb-4">
      <div class="card bg-light">
        <div class="card-body">
          <div *ngIf="!shouldUpdate && !changeFontFiles">
            <h4 class="text-center">File</h4>
            <span *ngFor="let fontType of font.types"
              ><a href="http://development.princelaw.com:4006/fonts/{{ fontType[1] }}">{{ fontType[0] }}</a> |</span
            >&nbsp;<button type="button" class="btn btn-primary btn-sm" (click)="changeFontFiles = true">Change font files</button>
            <h6>{{ font.default_font ? 'Default Font' : null }}</h6>
            <p>{{ font.description }}</p>
            <button type="button" class="btn btn-primary" (click)="shouldUpdate = true">Update Font</button>
          </div>
          <section id="change-font-files" *ngIf="changeFontFiles">
            <h4 class="text-center">Update font files</h4>
            <form #currentForm="ngForm" novalidate>
              <div class="form-group">
                <label for="regular"><p class="font-weight-bold">Font file - regular</p></label>
                <input type="file" class="form-control-file" id="regular" [uploader]="regUploader" ng2FileSelect />
                <p class="text-muted">Select the associated font file</p>
              </div>
              <div class="form-group">
                <label for="bold"><p class="font-weight-bold">Font file - bold</p></label>
                <input type="file" class="form-control-file" id="bold" [uploader]="boldUploader" ng2FileSelect />
                <p class="text-muted">Select the associated font file</p>
              </div>
              <div class="form-group">
                <label for="italic"><p class="font-weight-bold">Font file - italic</p></label>
                <input type="file" class="form-control-file" id="italic" [uploader]="italicUploader" ng2FileSelect />
                <p class="text-muted">Select the associated font file</p>
              </div>
              <div class="form-group">
                <label for="bold-italic"><p class="font-weight-bold">Font file - bold and italic</p></label>
                <input type="file" class="form-control-file" id="bold-italic" [uploader]="boldItalicUploader" ng2FileSelect />
                <p class="text-muted">Select the associated font file</p>
              </div>
              <div class="row">
                <div class="col">
                  <button type="button" class="btn btn-primary btn-sm" (click)="uploadFont(currentForm.form.valid)" [disabled]="formSubmitted">
                    {{ formSubmitted ? 'Uploading Font' : 'Upload Font' }}<span *ngIf="formSubmitted">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
                  </button>
                </div>
                <div class="col">
                  <button type="submit" class="btn btn-primary" (click)="changeFontFiles = false">Cancel</button>
                </div>
              </div>
            </form>
          </section>
          <section id="font-update" *ngIf="shouldUpdate">
            <h4 class="text-center">Update Font</h4>
            <form>
              <div class="form-group">
                <label for="font-name">Name</label>
                <input type="text" class="form-control" id="font-name" [(ngModel)]="updatedFontName" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" value="updatedFontName" />
              </div>
              <div class="form-group">
                <label for="font-description">Description</label>
                <input type="text" class="form-control" id="font-description" [(ngModel)]="updatedFontDesc" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" value="updatedFontDesc" />
              </div>
              <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="is-default" [(ngModel)]="isFontDefault" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" />
                <label class="form-check-label" for="is-default">Is default (overrides previous default font)</label>
              </div>
              <div class="row">
                <div class="col">
                  <button type="submit" class="btn btn-primary" (click)="updateFont()" [disabled]="formSubmitting">
                    {{ formSubmitting ? 'Updating Font' : 'Update Font' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
                  >&nbsp;
                  <button type="submit" class="btn btn-primary" (click)="shouldUpdate = false">Cancel</button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
    <div class="col-md-6 mb-4">
      <div class="card bg-light">
        <div class="card-body" id="preview">
          <h4 class="text-center">Preview</h4>
          <div id="upper-case">ABCDEFGHIJKLMNOPQRSTUVWXYZ</div>
          <div id="lower-case">abcdefghijklmnopqrstuvwxyz</div>
          <div id="numerics">0123456789</div>
          <div class="row">
            <div class="col-md-3">
              <table>
                <thead>
                  <tr>
                    <th colspan="2">Upper Case</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A</td>
                    <td>A</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>B</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>C</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>D</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>E</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>F</td>
                    <td>F</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>G</td>
                    <td>G</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>H</td>
                    <td>H</td>
                    <td>14</td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>I</td>
                    <td>6</td>
                  </tr>
                  <tr>
                    <td>J</td>
                    <td>J</td>
                    <td>6</td>
                  </tr>
                  <tr>
                    <td>K</td>
                    <td>K</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>L</td>
                    <td>L</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>M</td>
                    <td>M</td>
                    <td>16</td>
                  </tr>
                  <tr>
                    <td>N</td>
                    <td>N</td>
                    <td>14</td>
                  </tr>
                  <tr>
                    <td>O</td>
                    <td>O</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>P</td>
                    <td>P</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>Q</td>
                    <td>Q</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>R</td>
                    <td>R</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>S</td>
                    <td>S</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>T</td>
                    <td>T</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>U</td>
                    <td>U</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>V</td>
                    <td>12</td>
                  </tr>
                  <tr>
                    <td>W</td>
                    <td>W</td>
                    <td>16</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>X</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>Y</td>
                    <td>Y</td>
                    <td>11</td>
                  </tr>
                  <tr>
                    <td>Z</td>
                    <td>Z</td>
                    <td>11</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-3">
              <table>
                <thead>
                  <tr>
                    <th colspan="2">Lower Case</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>a</td>
                    <td>a</td>
                  </tr>
                  <tr>
                    <td>b</td>
                    <td>b</td>
                  </tr>
                  <tr>
                    <td>c</td>
                    <td>c</td>
                  </tr>
                  <tr>
                    <td>d</td>
                    <td>d</td>
                  </tr>
                  <tr>
                    <td>e</td>
                    <td>e</td>
                  </tr>
                  <tr>
                    <td>f</td>
                    <td>f</td>
                  </tr>
                  <tr>
                    <td>g</td>
                    <td>g</td>
                  </tr>
                  <tr>
                    <td>h</td>
                    <td>h</td>
                  </tr>
                  <tr>
                    <td>i</td>
                    <td>i</td>
                  </tr>
                  <tr>
                    <td>j</td>
                    <td>j</td>
                  </tr>
                  <tr>
                    <td>k</td>
                    <td>k</td>
                  </tr>
                  <tr>
                    <td>l</td>
                    <td>l</td>
                  </tr>
                  <tr>
                    <td>m</td>
                    <td>m</td>
                  </tr>
                  <tr>
                    <td>n</td>
                    <td>n</td>
                  </tr>
                  <tr>
                    <td>o</td>
                    <td>o</td>
                  </tr>
                  <tr>
                    <td>p</td>
                    <td>p</td>
                  </tr>
                  <tr>
                    <td>q</td>
                    <td>q</td>
                  </tr>
                  <tr>
                    <td>r</td>
                    <td>r</td>
                  </tr>
                  <tr>
                    <td>s</td>
                    <td>s</td>
                  </tr>
                  <tr>
                    <td>t</td>
                    <td>t</td>
                  </tr>
                  <tr>
                    <td>u</td>
                    <td>u</td>
                  </tr>
                  <tr>
                    <td>v</td>
                    <td>v</td>
                  </tr>
                  <tr>
                    <td>w</td>
                    <td>w</td>
                  </tr>
                  <tr>
                    <td>x</td>
                    <td>x</td>
                  </tr>
                  <tr>
                    <td>y</td>
                    <td>y</td>
                  </tr>
                  <tr>
                    <td>z</td>
                    <td>z</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-3">
              <table>
                <thead>
                  <tr>
                    <th colspan="2">Digits</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>6</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>7</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>8</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>9</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-3">
              <table>
                <thead>
                  <tr>
                    <th colspan="2">Special Characters</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>~</td>
                    <td>~</td>
                  </tr>
                  <tr>
                    <td>~</td>
                    <td>~</td>
                  </tr>
                  <tr>
                    <td>!</td>
                    <td>!</td>
                  </tr>
                  <tr>
                    <td>@</td>
                    <td>@</td>
                  </tr>
                  <tr>
                    <td>#</td>
                    <td>#</td>
                  </tr>
                  <tr>
                    <td>$</td>
                    <td>$</td>
                  </tr>
                  <tr>
                    <td>%</td>
                    <td>%</td>
                  </tr>
                  <tr>
                    <td>^</td>
                    <td>^</td>
                  </tr>
                  <tr>
                    <td>&</td>
                    <td>&</td>
                  </tr>
                  <tr>
                    <td>*</td>
                    <td>*</td>
                  </tr>
                  <tr>
                    <td>(</td>
                    <td>(</td>
                  </tr>
                  <tr>
                    <td>)</td>
                    <td>)</td>
                  </tr>
                  <tr>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                  <tr>
                    <td>_</td>
                    <td>_</td>
                  </tr>
                  <tr>
                    <td>=</td>
                    <td>=</td>
                  </tr>
                  <tr>
                    <td>+</td>
                    <td>+</td>
                  </tr>
                  <tr>
                    <td>/</td>
                    <td>/</td>
                  </tr>
                  <tr>
                    <td>[</td>
                    <td>[</td>
                  </tr>
                  <tr>
                    <td>]</td>
                    <td>]</td>
                  </tr>
                  <tr>
                    <td>\</td>
                    <td>\</td>
                  </tr>
                  <tr>
                    <td>|</td>
                    <td>|</td>
                  </tr>
                  <tr>
                    <td>:</td>
                    <td>:</td>
                  </tr>
                  <tr>
                    <td>;</td>
                    <td>;</td>
                  </tr>
                  <tr>
                    <td>,</td>
                    <td>,</td>
                  </tr>
                  <tr>
                    <td>.</td>
                    <td>.</td>
                  </tr>
                  <tr>
                    <td>?</td>
                    <td>?</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
